var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 4,
    fill: "#242A6B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1628 16.7396L17.5075 7.17045C17.3262 6.94318 16.9415 6.94318 16.7602 7.17045L9.1049 16.7396C8.99007 16.8831 8.96758 17.0797 9.04701 17.2458C9.12739 17.4118 9.29532 17.5171 9.47905 17.5171H13.7852V28.0431C13.7852 28.5708 14.2143 29 14.7421 29H19.5266C20.0544 29 20.4835 28.5708 20.4835 28.0431V17.5171H24.7896C24.9734 17.5171 25.1413 17.4118 25.2207 17.2458C25.3006 17.0802 25.2781 16.8831 25.1628 16.7396Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileActive);
export default __webpack_public_path__ + "static/media/file-active.af1d31311569617b1553dbd78770592d.svg";
export { ForwardRef as ReactComponent };